import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { branch } from 'baobab-react/higher-order';

//import Block from '@components/common/block';
import BLOCKS from '@store/blocks';
import PickCoordsBlock from '@components/containers/pick-coords-block';
import PickTestBlock from '@components/containers/pick-test-block';
import PerformTestBlock from '@components/containers/perform-test-block';
import comm from '@utils/comm';
import testingAPI from '@utils/testingGUIAPI';
import { AUGMENT_MARKS } from '@components/containers/main-map/actions'; //todo: remove unnecessary
import {
  CROSSHAIR_MOVE_DRIVING,
  OPEN_POPUP,
} from '@components/containers/test-panels-block/actions';
import { UPDATE_BALANCE } from '@components/containers/user-info-block/actions';

import { PARAM_CHANGE } from '@store/actions';
import { TEST_SELECTION } from '@components/containers/test-panels-block/actions';

import MAP_CONSTANTS from '../../../constants/map.json';

const multiCoords = function(activeTest) {
  switch (activeTest) {
    case 'gpr':
    case 'srr':
      return true;
    default:
      return false;
  }
};

const SAMPLES_KEYS = comm.dataStore.analysesNames.map(val => val.data);

class TestPanelsBlock extends React.Component {
  getPanels() {
    let panel = null;

    switch (this.props.activeTest) {
      case 'drilling':
      case 'exca':
      case 'mmd':
      case 'sgsa':
      case 'topo':
        panel = <PickCoordsBlock onStartPicking={this.onCoordPicking} />;
        break;
      case 'gpr':
      case 'srr':
        panel = (
          <Fragment>
            <PickCoordsBlock
              index={2}
              onStartPicking={this.onCoordPickingStart}
            />
            <PickCoordsBlock
              index={3}
              onStartPicking={this.onCoordPickingEnd}
            />
          </Fragment>
        );
        break;
      default:
    }

    return panel;
  }

  constructor(props) {
    super(props);

    this.drilling_onDrill = () => {
      testingAPI.drillButtonCB(this.props.dispatch.bind(null, OPEN_POPUP));
      this.props.dispatch(UPDATE_BALANCE, comm.dataStore.balance);
    };
    this.drilling_onPush = () => {
      testingAPI.pushButtonCB(this.props.dispatch.bind(null, OPEN_POPUP));
      this.props.dispatch(UPDATE_BALANCE, comm.dataStore.balance);
    };
    this.drilling_onAnalysisSelection = idx => {
      if (idx !== 0) {
        testingAPI.testState.method = SAMPLES_KEYS[idx];
        testingAPI.analysis(this.props.dispatch.bind(null, OPEN_POPUP), null);
        this.props.dispatch(UPDATE_BALANCE, comm.dataStore.balance);
      }
      this.setState({
        analysisValue: SAMPLES_KEYS[0], //SAMPLES_KEYS[idx]
      });
    };

    this.mmd_onDrivingDirection = delta => {
      const testXNext = this.props.crosshairPicking[0].x + delta[0];
      const testYNext = this.props.crosshairPicking[0].y + delta[1];
      if (
        testXNext > MAP_CONSTANTS.main.width ||
        testYNext > MAP_CONSTANTS.main.height ||
        testXNext < 0 ||
        testYNext < 0
      ) {
        return false;
      }
      //this.onCoordPicking();
      this.props.dispatch(CROSSHAIR_MOVE_DRIVING, {
        x: testXNext,
        y: testYNext,
      });
      //this.props.dispatch(CROSSHAIR_SETUP_DRIVING);

      testingAPI.setStateCoords(testXNext, testYNext);
      /*return */ this.onPerform();
    };
    this.mmd_onShowButtons = () => {
      if (!testingAPI.validateTest()) {
        this.props.dispatch(OPEN_POPUP, 'error_drill_invalid');
        return false;
      }
      return true;
    };

    this.onPerform = () => {
      testingAPI.performTest.call(
        testingAPI,
        () => {
          this.forceUpdate.call(this);
          this.props.dispatch(
            AUGMENT_MARKS,
            comm.dataStore.getTestsAmountByName(this.props.activeTest),
          );
          this.props.dispatch(UPDATE_BALANCE, comm.dataStore.balance);
        },
        this.props.dispatch.bind(null, OPEN_POPUP),
        this.props.activeTest !== 'mmd',
      );
      //this.forceUpdate();
      //if mmd: props.dispatch(this, PARAM_CHANGE, BLOCKS.MAP.CROSSHAIR_SETTING, 0);
      //on cancel: props.dispatch.bind(null, CROSSHAIR_CANCEL);
    };
    this.onTestChange = testName => {
      testingAPI.testState.init(testName);
      testingAPI.setup(testName);
      //testingAPI.eraseResults();
    };
    this.onTestSelection = testName => {
      testingAPI.eraseResults();
      props.dispatch(TEST_SELECTION, testName);
    };
    //this.resetMapPickableParams = props.dispatch.bind(null, RESET_MAP_PICKABLE_PARAMS);

    this.onCoordPicking = props.dispatch.bind(
      this,
      PARAM_CHANGE,
      BLOCKS.MAP.CROSSHAIR_SETTING,
      0,
    );
    this.onCoordPickingStart = props.dispatch.bind(
      this,
      PARAM_CHANGE,
      BLOCKS.MAP.CROSSHAIR_SETTING,
      0,
    );
    this.onCoordPickingEnd = props.dispatch.bind(
      this,
      PARAM_CHANGE,
      BLOCKS.MAP.CROSSHAIR_SETTING,
      1,
    );

    this.state = {
      analysisValue: SAMPLES_KEYS[0],
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.activeTest !== this.props.activeTest) {
      this.onTestChange(this.props.activeTest);
    }
  }

  componentWillMount() {
    this.onTestChange(this.props.activeTest);
    //this.onTestSelection(INIT_TEST);
    //this.resetMapPickableParams();
  }

  render() {
    let props = this.props;
    let Panels = this.getPanels();
    let resultsTxt = props.crosshairPicking && testingAPI.displayedResults; //displayResults();

    return (
      <Fragment>
        <PickTestBlock
          value={props.activeTest}
          onChange={this.onTestSelection}
          short={multiCoords(props.activeTest)}
        />
        {Panels}
        <PerformTestBlock
          activeTest={props.activeTest}
          drilling_onDrill={this.drilling_onDrill}
          drilling_onPush={this.drilling_onPush}
          drilling_onAnalysisSelection={this.drilling_onAnalysisSelection}
          drilling_analysisValue={this.state.analysisValue}
          onPerform={this.onPerform}
          mmd_onDrivingDirection={this.mmd_onDrivingDirection}
          mmd_onShowButtons={this.mmd_onShowButtons}
          resultsTxt={resultsTxt}
          short={multiCoords(props.activeTest)}
        />
      </Fragment>
    );
  }
}

TestPanelsBlock.propTypes = {
  activeTest: PropTypes.string.isRequired,
  crosshairPicking:
    PropTypes.array /*PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  })*/,
};

export default branch(
  {
    activeTest: BLOCKS.TEST_PANELS.ACTIVE_TEST,
    crosshairPicking: BLOCKS.MAP.ACTIVE_MARKERS,
    //popupShown: BLOCKS.APP.POPUP
  },
  TestPanelsBlock,
);
